/* CILSON – Startseite: "Alle Kabelkanäle ansehen" oben und unten */
(() => {
  if (window.cilsonHome) return;
  window.cilsonHome = true;
  const URL_ALL = '/collections/kabelkanaele';
  const LABEL = 'Alle Kabelkanäle ansehen';

  const run = () => {
    const sec = document.querySelector('[id$="__featured-collection-0"]');
    if (!sec) return;
    const btn = sec.querySelector('.collection__view-all a');
    if (btn && btn.dataset.cil !== '1') {
      btn.dataset.cil = '1';
      btn.href = URL_ALL;
      btn.textContent = LABEL;
      btn.setAttribute('aria-label', LABEL);
    }
    const title = sec.querySelector('.collection__title');
    if (title && !title.querySelector('.cil-viewall-top')) {
      const a = document.createElement('a');
      a.className = 'cil-viewall-top';
      a.href = URL_ALL;
      a.innerHTML = 'Alle 32 Größen ansehen <span aria-hidden="true">›</span>';
      const h = title.querySelector('h2');
      (h || title).insertAdjacentElement('afterend', a);
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  setTimeout(run, 1200);
})();
